import styled from 'styled-components';

export const OccupationDetails = styled.div`

`
